export const development = {
  // 使用空字符串会通过Vite代理，或者直接连接staging
  apiBase: process.env.API_BASE ?? "",
  // 显式配置
  apiBaseStaging: "https://api.staging.pannovation.com",
  apiBaseProduction: "https://api.pannovation.com",
  homeSosListClock: Number(process.env.HOME_SOS_LIST_CLOCK) || 30000000,
  latestLocationsNumber: 10,
  latestLocationsInterval: 10000,
  onlineStatusDetectInterval: 15000,
  BATTERY_LIFE_CHART_DAYS: Number(process.env.BATTERY_LIFE_CHART_DAYS) || 5,
  STEP_COUNT_CHART_DAYS: Number(process.env.STEP_COUNT_CHART_DAYS) || 5,
  IMMEDIATE_ALERT_TIMEFRAME: Number(process.env.IMMEDIATE_ALERT_TIMEFRAME) || 5 * 60 * 1000, //milsec, default: 5 min
  RECENT_LOCATION_TIMEFRAME: Number(process.env.RECENT_LOCATION_TIMEFRAME) || 30 * 60 * 1000, //  milsec, default: 30 min
  GOOD_ALERT_ACCURACY_THRESHOLD: Number(process.env.GOOD_ALERT_ACCURACY_THRESHOLD) || 60, //meters, default: 60 meters
  IMMEDIATE_ALERT_POLLING_DURING: Number(process.env.IMMEDIATE_ALERT_TIMEFRAME) || 5 * 60 * 1000, //milsec, default: 5 min
  IMMEDIATE_ALERT_POLLING_INTERVAL:
    Number(process.env.IMMEDIATE_ALERT_POLLING_INTERVAL) || 30 * 1000, //milsec, default: 30 sec
  RECENT_ALERT_TIMEFRAME: Number(process.env.RECENT_ALERT_TIMEFRAME) || 30 * 60 * 1000, //  milsec, default: 30 min,
  ONCALL_STATUS_DEFINITION: Number(process.env.RECENT_ALERT_TIMEFRAME) || 30 * 60 * 1000, //  milsec, default: 30 min,
  RECENT_ALERT_TRIGGER_LAST_KNOWN_LOCATION_DURATION:
    Number(process.env.RECENT_ALERT_TRIGGER_LAST_KNOWN_LOCATION_DURATION) || 2.5 * 60, //  second, default: 2.5 min,
  ALERT_POLLING_INTERVAL: Number(process.env.ALERT_POLLING_INTERVAL) || 20 * 1000, // milsec default: 20s,
  LAST_KNOWN_LOCATION_RETRIEVING_RATE:
    Number(process.env.LAST_KNOWN_LOCATION_RETRIEVING_RATE) || 5000, // milsec
  NO_LOCATIONS_REPORTED_DURATION: Number(process.env.NO_LOCATIONS_REPORTED_DURATION) || 70, //second, default: 35 sec
  NO_VALID_LOCATIONS_IN_N_SECONDS: Number(process.env.NO_VALID_LOCATIONS_IN_N_SECONDS) || 70, //second, default: 30 sec
  POST_ALERT_GPS_TIME_LIMIT: Number(process.env.POST_ALERT_GPS_TIME_LIMIT) || 200, //second, default: 200 sec
  APP_ENV_IS_ONBOARDING_ENV: process.env.APP_ENV_IS_ONBOARDING_ENV || false,
};
